import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faCircleInfo } from '@fortawesome/pro-light-svg-icons'
import { Tooltip } from 'react-tooltip';
import './question-help.scss';
import Popup from '../popup/Popup';
import { useState } from 'react';
import PASHelp from './PA&SHelp';

export default function QuestionHelp(props: any) {
    const [isPopupOpen, setIsPopupOpen] = useState(false);

    function disableScrolling() {
        var x = window.scrollX;
        var y = window.scrollY;
        window.onscroll = function () { window.scrollTo(x, y); };
    }

    function enableScrolling() {
        window.onscroll = function () { };
    }

    const togglePopup = () => {
        if (!isPopupOpen) {
            disableScrolling();
        } else {
            enableScrolling();
        }

        setIsPopupOpen(!isPopupOpen);
    }

    return <>
        {props.helpText.includes("PA&S") &&
        <>
            <span
                className="help-icon"
                data-tooltip-id={`${props.questionID}-question-help`}
                onClick={() => togglePopup()}>
                <span className="help-icon"><FontAwesomeIcon icon={faCircleInfo} /></span>
            </span>
            {isPopupOpen && <Popup
                content={<>
                    <div>
                        <PASHelp />
                    </div>
                </>}
                handleClose={togglePopup}
            />}
        </>
        }
        {!props.helpText.includes("PA&S") &&
            <span
                className="help-icon"
                data-tooltip-id={`${props.questionID}-question-help`}

            >
                <FontAwesomeIcon icon={faCircleInfo} />
                <Tooltip
                    id={`${props.questionID}-question-help`}
                    place="bottom"
                    openOnClick={true}
                    className="help-text"
                >
                    <div>
                        {props.helpText}
                    </div>
                </Tooltip>
            </span>
        }
    </>
}